import { gql } from '@apollo/client';

export const Classe = {
  fragments: {
    info: gql`
      fragment ClasseInfo on Classe {
        debut
        fin
        name
        operationid
        filliere {
          data {
            id
            attributes {
              name
            }
          }
        }
        lycee {
          data {
            id
            attributes {
              name
            }
          }
        }
        niveau {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    `
  }
};
